import React from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';

import { customThemes } from '../../lib/themes';

import styles from './styles.module.scss';

const HighlightRow = ({
  children,
  padding,
  background,
  className,
  tag,
  ...props
}) =>
  React.createElement(
    tag,
    {
      className: cc([
        styles.container,
        styles[background],
        { [styles.padding]: padding },
        className,
      ]),
      ...props,
    },
    children
  );

HighlightRow.propTypes = {
  padding: PropTypes.bool,
  background: PropTypes.oneOf(
    customThemes(['transparent', 'light', 'dark', 'sky', 'clouds'])
  ),
  tag: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

HighlightRow.defaultProps = {
  padding: false,
  background: 'light',
  tag: 'div',
};

export default HighlightRow;
